// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'development',
  googleTagManagerId: 'GTM-5QGNF9N',
  sweetDashboardAppUrl: 'https://dev.sweetanalytics.com',
  hubspotPortalId: '25217964',
  hubspotFormGuid: '9613a014-e835-4181-b0ad-502f12012143',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
